declare global {
  interface Window {
    pixelId: string
    utmify: {
      track: (event: string) => void
    }
  }
}

let pixelInitialized = false

export function initUtmifyPixel(): void {
  if (typeof window === 'undefined' || pixelInitialized) return
  pixelInitialized = true

  window.pixelId = '69a7932b3113b8568e86ce51'

  const script = document.createElement('script')
  script.async = true
  script.defer = true
  script.src = 'https://cdn.utmify.com.br/scripts/pixel/pixel.js'
  document.head.appendChild(script)
}

export function trackInitiateCheckout(): void {
  if (typeof window !== 'undefined' && window.utmify) {
    window.utmify.track('InitiateCheckout')
  }
}
